import { Injectable } from '@angular/core';
import type * as CountryStateCity from 'country-state-city';

export interface CountryInfo {
  name: string;
  isoCode: string;
}

export interface StateInfo {
  name: string;
  isoCode: string;
}

export interface CityInfo {
  name: string;
  stateCode: string;
  countryCode: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private modulePromise: Promise<typeof CountryStateCity> | null = null;

  private loadModule(): Promise<typeof CountryStateCity> {
    if (!this.modulePromise) {
      this.modulePromise = import('country-state-city');
    }

    return this.modulePromise;
  }

  async getCountries(): Promise<CountryInfo[]> {
    const { Country } = await this.loadModule();
    return Country.getAllCountries();
  }

  async getStates(countryCode: string): Promise<StateInfo[]> {
    if (!countryCode) {
      return [];
    }

    const { State } = await this.loadModule();
    return State.getStatesOfCountry(countryCode);
  }

  async getCities(countryCode: string, stateCode: string): Promise<CityInfo[]> {
    if (!countryCode || !stateCode) {
      return [];
    }

    const { City } = await this.loadModule();
    return City.getCitiesOfState(countryCode, stateCode);
  }
}
